var exports = {
  "kL": "xe564cbfb--2a9009--container",
  "Qs": "xe564cbfb--2a9009--content",
  "Qq": "xe564cbfb--2a9009--text",
  "Sl": "xe564cbfb--2a9009--image",
};

module.exports = exports;
